import React, { useState, useEffect } from "react";

const AwesomePagination = ({ pagina, totalPaginas, setPagina }) => {
  const [inputValue, setInputValue] = useState(pagina);

  useEffect(() => {
    setInputValue(pagina);
  }, [pagina]);

  const handleInputChange = (e) => {
    let val = Number(e.target.value);
    if (val > totalPaginas) val = totalPaginas;
    if (val < 1) val = 1;
    setInputValue(val);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter") {
      setPagina(inputValue);
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 w-100">
      <div></div>
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn btn-primary btn-sm"
          disabled={pagina <= 1}
          onClick={() => setPagina((p) => Math.max(1, p - 1))}
        >
          <i className="ri-arrow-left-s-line"></i>
        </button>
        <span>
          Page <b>{pagina}</b> of <b>{totalPaginas}</b>
        </span>
        <input
          type="number"
          min={1}
          max={totalPaginas}
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyDown}
          style={{ width: 50, textAlign: "center" }}
          className="form-control form-control-sm mx-2"
        />
        <button
          className="btn btn-primary btn-sm"
          disabled={pagina >= totalPaginas}
          onClick={() => setPagina((p) => Math.min(totalPaginas, p + 1))}
        >
          <i className="ri-arrow-right-s-line"></i>
        </button>
      </div>
      <div></div>
    </div>
  );
};

export default AwesomePagination; 